import { getApiUrl } from './api';

const API_URL = getApiUrl();

export const WAITER_DEVICE_STORAGE_KEY = 'brutos-waiter-device-session';

export const getWaiterDeviceSession = () => {
  if (typeof window === 'undefined') return null;

  try {
    const raw = window.localStorage.getItem(WAITER_DEVICE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.token ? parsed : null;
  } catch {
    return null;
  }
};

const storeWaiterDeviceSession = (session) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(WAITER_DEVICE_STORAGE_KEY, JSON.stringify(session));
};

export const clearWaiterDeviceSession = () => {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(WAITER_DEVICE_STORAGE_KEY);
};

const toHeaders = (headers) => (
  headers instanceof Headers ? new Headers(headers) : new Headers(headers || {})
);

export const waiterDeviceFetch = async (path, options = {}) => {
  const session = getWaiterDeviceSession();
  const headers = toHeaders(options.headers);

  if (session?.token && !headers.has('X-Waiter-Token')) {
    headers.set('X-Waiter-Token', session.token);
  }

  const url = /^https?:\/\//i.test(path) ? path : `${API_URL}${path}`;
  const response = await fetch(url, { ...options, headers });

  // Erros de negócio não encerram uma sessão válida do aparelho.
  if (response.status === 401) {
    clearWaiterDeviceSession();
  }

  return response;
};

export const connectWaiterDevice = async (pin) => {
  const response = await fetch(`${API_URL}/api/salon/device/connect`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pin }),
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false || !data.token) {
    throw new Error('WAITER_PIN_INVALID');
  }

  const session = {
    token: data.token,
    expiresAt: data.expiresAt || '',
    company: data.company || null,
  };
  storeWaiterDeviceSession(session);
  return session;
};

export const fetchWaiterDeviceSession = async () => {
  const response = await waiterDeviceFetch('/api/salon/device/session');
  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success === false) {
    const error = new Error('WAITER_SESSION_INVALID');
    error.status = response.status;
    error.code = data.code || 'WAITER_SESSION_INVALID';
    throw error;
  }

  const current = getWaiterDeviceSession();
  if (current?.token) {
    storeWaiterDeviceSession({
      ...current,
      expiresAt: data.expiresAt || current.expiresAt || '',
      company: data.company || current.company || null,
    });
  }

  return data;
};
